import { qdfoodApi } from './constant';
import { Locations } from '@type/locations';

export const LOCATION_API = {
  urlGetLocation: `/location`,
};

export default class locationApi {
  static getLocation() {
    return qdfoodApi().get<Locations>(LOCATION_API.urlGetLocation);
  }
}
